/**
 * Account message API calls.
 */
import api from "@/utils/axios";
import type { PagedResponse } from "@/types/pagination.types";
import type { UserMessage } from "@/types/message.types";

export interface AccountMessageQuery {
  page?: number;
  size?: number;
  unreadOnly?: boolean;
}

const buildMessageParams = (query?: AccountMessageQuery) => {
  const params = new URLSearchParams();
  if (!query) return params;
  if (query.page !== undefined) params.set("page", String(query.page));
  if (query.size !== undefined) params.set("size", String(query.size));
  if (query.unreadOnly !== undefined) {
    params.set("unreadOnly", String(query.unreadOnly));
  }
  return params;
};

export const messageService = {
  async getMessages(
    query?: AccountMessageQuery
  ): Promise<PagedResponse<UserMessage>> {
    const params = buildMessageParams(query);
    const queryString = params.toString();
    const url = `/account/messages${queryString ? `?${queryString}` : ""}`;
    const response = await api.get<PagedResponse<UserMessage>>(url);
    return response.data;
  },

  async markMessageRead(messageId: string): Promise<UserMessage> {
    const response = await api.patch<UserMessage>(
      `/account/messages/${encodeURIComponent(messageId)}/read`
    );
    return response.data;
  },

  async markAllRead(): Promise<void> {
    await api.post("/account/messages/mark-all-read");
  },

  async getUnreadCount(): Promise<number> {
    const response = await messageService.getMessages({
      page: 0,
      size: 1,
      unreadOnly: true,
    });
    return response.totalElements;
  },
};
